export default "__VITE_ASSET__459e1153__"